import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import { Permission } from 'core/api';
import createNewTicket from './createNewTicket';

declare global {
	interface CommandType {
		parkTicket: () => Promise<Result>
	}
}

Command.register('parkTicket', Preconditions.ensure(Permission.Ticket_Park), async (): Promise<Result> => {
	return await createNewTicket();
});
